module.exports = __webpack_public_path__ + "img/3d_payment_deadline.73bd0de1.svg";